module.exports = __webpack_public_path__ + "images/tidings-bom-imag-new.1789440611829.png";